import { Space, Spin } from "antd";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import { usePLCGWStatus } from "./index.hook";
import styles from "./index.module.less";
import { RootState } from "../../../appRedux/store";
import { SideMenuItemKeys } from "../../../constants/ApplicationConstants/RouteConstants";
import { Modules } from "../../../constants/DatabaseConstants/MasterConstant";
import { allowedDropdownList, allowedLocationDropdownList } from "../../../constants/ApplicationConstants/MasterConstant";
import moment from "moment-timezone";
import { GWStatusConstants, PLCStatusConstants } from "../../../constants/DatabaseConstants/ParkingConstants";

const StatusDot = ({ status }: { status: number | undefined | null }) => {
  let dotClass = "";
  let statusText = "";
  let statusTextColor = "";

  switch (status) {
    case GWStatusConstants.CONNECTED:
    case PLCStatusConstants.CONNECTED:
      dotClass = styles.greenDot;
      statusTextColor = styles["text-color-green"];
      statusText = "Connected";
      break;
    case GWStatusConstants.DISCONNECTED:
    case PLCStatusConstants.DISCONNECTED:
      dotClass = styles.redDot;
      statusTextColor = styles["text-color-red"];
      statusText = "Disconnected";
      break;

    case PLCStatusConstants.GW_INACTIVE:
      dotClass = styles.redDot;
      statusTextColor = styles["text-color-red"];
      statusText = "Gateway Inactive";
      break;

    default:
      dotClass = styles.blackDot;
      statusTextColor = styles["text-color-black"];
      statusText = "No device found";
  }

  return (
    <div className={styles["status-container"]}>
      <span className={`${styles.dot} ${dotClass}`}></span>
      <span className={`${styles["status-text"]} ${statusTextColor}`}>{statusText}</span>
    </div>
  );
};

const PLCGWStatusCard = () => {
  const location = useLocation();

  const config = usePLCGWStatus();

  const { masterFilters } = useSelector(({ common }: RootState) => common);

  const pathSegments = location.pathname?.split("/");
  const segment1 = pathSegments[1] as SideMenuItemKeys;
  const segment2 = pathSegments[2] as Modules;

  const isSegment1Allowed = pathSegments && allowedDropdownList?.includes(segment1);
  const isSegment2Allowed = allowedLocationDropdownList?.includes(segment2);
  const isCustomerAndLocationSet = masterFilters?.customerId && masterFilters?.locationId;

  return (
    <div>
      {isSegment1Allowed && isSegment2Allowed && isCustomerAndLocationSet && (
        <div className={styles["status-card-container"]}>
          {config.loading ? (
            <Space direction="vertical" className={styles["space--width"]} size="small">
              <Spin tip="Loading" size="small" style={{ margin: 0 }} />
            </Space>
          ) : (
            <>
              <div className={styles["section2"]}>
                <span className={styles["label1"]}>GW </span>
                <StatusDot status={config?.data?.gatewayStatus} />
              </div>
              <div className={styles["section1"]}>
                <span className={styles["label2"]}>PLC </span>
                <StatusDot status={config?.data?.plcStatus} />
              </div>
              <div>
                <span className={styles["createdOn-date"]}>{config?.data?.iotHubDeviceToCloudLog_createdOn ? `(${moment(config?.data?.iotHubDeviceToCloudLog_createdOn).format("DD-MM-YYYY HH:mm")})` : ""}</span>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default PLCGWStatusCard;
